// modules/admin/SiteBuilder/components/ComponentList.tsx

import React from 'react';
import { Plus } from 'lucide-react';

interface Component {
  type: string;
  name: string;
  icon: string;
  description: string;
}

interface Props {
  components: Component[];
  onAddComponent: (type: string) => void;
}

export const ComponentList: React.FC<Props> = ({ components, onAddComponent }) => {
  return (
    <div className="p-4">
      <div className="mb-4">
        <h3 className="text-lg font-bold text-gray-900">Componentes Disponíveis</h3>
        <p className="text-sm text-gray-600">Clique para adicionar à página</p>
      </div>
      
      <div className="space-y-2">
        {components.map((component) => (
          <button
            key={component.type}
            onClick={() => onAddComponent(component.type)}
            className="w-full text-left border-2 border-gray-200 rounded-lg p-3 hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all group"
          >
            <div className="flex items-center gap-3">
              <div className="text-3xl">{component.icon}</div>
              <div className="flex-1">
                <div className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {component.name}
                </div>
                <div className="text-xs text-gray-500 mt-0.5">
                  {component.description}
                </div>
              </div>
              <div className="opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                <Plus size={20} className="text-blue-600" />
              </div>
            </div>
          </button>
        ))}
      </div>
      
      <div className="mt-6 p-3 bg-purple-50 border border-purple-200 rounded-lg">
        <p className="text-xs text-purple-800">
          💡 <strong>Dica:</strong> Arraste os componentes na página para reordenar
        </p>
      </div>
    </div>
  );
};
